// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.system-upload-file .el-upload-dragger{\n  width: 450px;\n  height: 130px;\n}\n.system-upload-file .el-icon-upload{\n  font-size: 34px;\n  color: #D3D7DF;\n  margin: 28px 0 16px;\n  line-height: 1;\n}\n.system-upload-file .el-upload__tip{\n  font-size: 12px;\n  color: #909399;\n  margin-top: 8px;\n  line-height: 1.5;\n}\n", ""]);
// Exports
module.exports = exports;
